import React from 'react';
import classNames from 'classnames';

import { useAppSelector } from 'src/app/hooks';

import { CreditsModal } from './CreditsModal';
import { selectCreditsOpen } from 'src/state';
import styles from './Overlay.module.css';

interface Props {}

export function MobileCreditsOverlay(props: Props) {
  const creditsAreOpen = useAppSelector(selectCreditsOpen);

  const mobileOverlayClasses = classNames(
    styles['mobile-overlay'],
    {
      [styles['mobile-overlay--open']]: creditsAreOpen,
    },
  );

  return (
    <div className={mobileOverlayClasses} >
      <CreditsModal className={styles['mobile-overlay__credits']}/>
    </div>
  )
}
